<div class="bcu-dropdown-container form-label-group" [ngClass]="{ 'is-disabled': isDisabled }">
    <input type="text" class="form-control" [placeholder]="placeHolder" [value]="selectedDisplayText"
         (click)="toggleSelectDropDown($event)" id="input_select"
         [formControl]="searchInput" autocomplete="off"
         type="text" [ngClass]="getInputClass()" />
    <div class="arrow-down" (click)="toggleSelectDropDown($event)" [ngClass]="getArrowClass()"></div>
    <div class="bcu-dropdown-list-container" *ngIf="toggleDropDown" [ngStyle]="getDropDownStyle()">
        <ul class="available-items">
            <li class="pl-2" *ngFor="let groupItem of filteredItems" (click)="itemClick(groupItem)"
            [ngClass]="{'item-selected': isItemSelected(groupItem)}"
            >
                <div
                    [ngClass]="{'group-list-item': groupItem.groupItem, 'normal-list-item': !groupItem.groupItem}">
                    <div *ngIf="multiple">
                        <div class="checkbox-container "> <input class="item-checkbox" type="checkbox"
                                [checked]="isItemSelected(groupItem)" (click)="itemClick(groupItem)">
                            <span class="check-mark"></span></div>
                    </div>
                    <div [ngClass]="{'item-padding': multiple}">
                        <span>{{groupItem.displayName}}</span>
                    </div>
                </div>
            </li>
            <li class="normal-list-item" *ngIf="noItems">
                <span translate>GroupDropDown.NoRecords</span>
            </li>
        </ul>
    </div>
</div>
